/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OrdersTable_orderEdges$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type OrdersDue_orderEdges$ref: FragmentReference;
declare export opaque type OrdersDue_orderEdges$fragmentType: OrdersDue_orderEdges$ref;
export type OrdersDue_orderEdges = $ReadOnlyArray<{|
  +$fragmentRefs: OrdersTable_orderEdges$ref,
  +$refType: OrdersDue_orderEdges$ref,
|}>;
export type OrdersDue_orderEdges$data = OrdersDue_orderEdges;
export type OrdersDue_orderEdges$key = {
  +$data?: OrdersDue_orderEdges$data,
  +$fragmentRefs: OrdersDue_orderEdges$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "OrdersDue_orderEdges",
  "type": "OrderEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "OrdersTable_orderEdges",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a7d6e40864fbc26f19be62c999acec96';
module.exports = node;
